import { IonInput, IonLabel, IonText } from '@ionic/react';
import {
  ControlProps,
  ControlState,
  computeLabel,
  isStringControl,
  rankWith,
} from '@jsonforms/core';
import { Control, withJsonFormsControlProps } from '@jsonforms/react';
import { merge } from 'lodash';
import { IonItem } from '../../ionic/IonItem';

class IonicTextInputControlInner extends Control<ControlProps, ControlState> {
  private hasFocused = false;
  render() {
    const {
      data,
      description,
      enabled,
      errors,
      label,
      uischema,
      visible,
      required,
      config,
      handleChange,
      path,
    } = this.props;

    const appliedUiSchemaOptions = merge({}, config, uischema.options);

    const errorText = this.hasFocused ? (
      <IonText color="danger">{errors}</IonText>
    ) : null;

    const className = visible === false ? 'ion-hide' : '';

    const computedLabel = computeLabel(
      typeof label === 'string' ? label : '',
      required ?? false,
      appliedUiSchemaOptions.hideRequiredAsterisk
    );

    return (
      <IonItem lines={'full'} className={className}>
        <IonInput
          aria-label={computedLabel}
          labelPlacement="floating"
          placeholder={description}
          value={data}
          disabled={!enabled}
          onIonInput={(e) => {
            if (e.detail.value !== undefined) {
              handleChange(path, e.detail.value);
            }
          }}
          onIonFocus={() => {
            this.hasFocused = true;
            this.onFocus();
          }}
          onIonBlur={() => {
            this.onBlur();
          }}
        >
          <div slot="label">
            <IonLabel color="primary">
              {computedLabel} {errorText}
            </IonLabel>
          </div>
        </IonInput>
      </IonItem>
    );
  }
}

const IonicTextInputTester = rankWith(1, isStringControl);
const IonicTextInputControl = withJsonFormsControlProps(
  IonicTextInputControlInner
);
export { IonicTextInputControl, IonicTextInputTester };
